"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftUpdateDto = instanceOfShiftUpdateDto;
exports.ShiftUpdateDtoFromJSON = ShiftUpdateDtoFromJSON;
exports.ShiftUpdateDtoFromJSONTyped = ShiftUpdateDtoFromJSONTyped;
exports.ShiftUpdateDtoToJSON = ShiftUpdateDtoToJSON;
exports.ShiftUpdateDtoToJSONTyped = ShiftUpdateDtoToJSONTyped;
const OnCallShiftCreateDto_1 = require("./OnCallShiftCreateDto");
const DirectRequestFallback_1 = require("./DirectRequestFallback");
const StipendCreateDto_1 = require("./StipendCreateDto");
const ShiftType_1 = require("./ShiftType");
const BonusUpdateDto_1 = require("./BonusUpdateDto");
const ShiftTime_1 = require("./ShiftTime");
const LicenseType_1 = require("./LicenseType");
/**
 * Check if a given object implements the ShiftUpdateDto interface.
 */
function instanceOfShiftUpdateDto(value) {
    return true;
}
function ShiftUpdateDtoFromJSON(json) {
    return ShiftUpdateDtoFromJSONTyped(json, false);
}
function ShiftUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'shiftTime': json['shiftTime'] == null ? undefined : (0, ShiftTime_1.ShiftTimeFromJSON)(json['shiftTime']),
        'shiftType': json['shiftType'] == null ? undefined : (0, ShiftType_1.ShiftTypeFromJSON)(json['shiftType']),
        'licenseType': json['licenseType'] == null ? undefined : (0, LicenseType_1.LicenseTypeFromJSON)(json['licenseType']),
        'totalRate': json['totalRate'] == null ? undefined : json['totalRate'],
        'description': json['description'] == null ? undefined : json['description'],
        'isSearchable': json['isSearchable'] == null ? undefined : json['isSearchable'],
        'stipendMinimumDistance': json['stipendMinimumDistance'] == null ? undefined : json['stipendMinimumDistance'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'customStartTime': json['customStartTime'] == null ? undefined : json['customStartTime'],
        'customEndTime': json['customEndTime'] == null ? undefined : json['customEndTime'],
        'specialtyCode': json['specialtyCode'] == null ? undefined : json['specialtyCode'],
        'stipends': json['stipends'] == null ? undefined : (json['stipends'].map(StipendCreateDto_1.StipendCreateDtoFromJSON)),
        'onCallShift': json['onCallShift'] == null ? undefined : (0, OnCallShiftCreateDto_1.OnCallShiftCreateDtoFromJSON)(json['onCallShift']),
        'directRequestNurseId': json['directRequestNurseId'] == null ? undefined : json['directRequestNurseId'],
        'directRequestFallback': json['directRequestFallback'] == null ? undefined : (0, DirectRequestFallback_1.DirectRequestFallbackFromJSON)(json['directRequestFallback']),
        'orientationOpportunityId': json['orientationOpportunityId'] == null ? undefined : json['orientationOpportunityId'],
        'payRate': json['payRate'] == null ? undefined : json['payRate'],
        'platformFeePct': json['platformFeePct'] == null ? undefined : json['platformFeePct'],
        'employerFeePct': json['employerFeePct'] == null ? undefined : json['employerFeePct'],
        'bonus': json['bonus'] == null ? undefined : (0, BonusUpdateDto_1.BonusUpdateDtoFromJSON)(json['bonus']),
    };
}
function ShiftUpdateDtoToJSON(json) {
    return ShiftUpdateDtoToJSONTyped(json, false);
}
function ShiftUpdateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'shiftTime': (0, ShiftTime_1.ShiftTimeToJSON)(value['shiftTime']),
        'shiftType': (0, ShiftType_1.ShiftTypeToJSON)(value['shiftType']),
        'licenseType': (0, LicenseType_1.LicenseTypeToJSON)(value['licenseType']),
        'totalRate': value['totalRate'],
        'description': value['description'],
        'isSearchable': value['isSearchable'],
        'stipendMinimumDistance': value['stipendMinimumDistance'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString().substring(0, 10)),
        'customStartTime': value['customStartTime'],
        'customEndTime': value['customEndTime'],
        'specialtyCode': value['specialtyCode'],
        'stipends': value['stipends'] == null ? undefined : (value['stipends'].map(StipendCreateDto_1.StipendCreateDtoToJSON)),
        'onCallShift': (0, OnCallShiftCreateDto_1.OnCallShiftCreateDtoToJSON)(value['onCallShift']),
        'directRequestNurseId': value['directRequestNurseId'],
        'directRequestFallback': (0, DirectRequestFallback_1.DirectRequestFallbackToJSON)(value['directRequestFallback']),
        'orientationOpportunityId': value['orientationOpportunityId'],
        'payRate': value['payRate'],
        'platformFeePct': value['platformFeePct'],
        'employerFeePct': value['employerFeePct'],
        'bonus': (0, BonusUpdateDto_1.BonusUpdateDtoToJSON)(value['bonus']),
    };
}
//# sourceMappingURL=ShiftUpdateDto.js.map